import { inject } from '@angular/core';

import { Package, PackageConfiguratorService } from '@lib/insurance-packages/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, catchError, map, of, switchMap, tap } from 'rxjs';

import {
  getClientPackagesOptions,
  getClientPackagesOptionsFailure,
  getClientPackagesOptionsSuccess,
  setClientCreateUiStep,
} from '@admin/store/client-create-ui/client-create-ui.actions';

export const setClientCreateUiStepEffect = createEffect(
  (actions$ = inject(Actions)): Observable<Action> =>
    actions$.pipe(
      ofType(setClientCreateUiStep),
      tap(() => {
        // console.log('setClientCreateUiStepEffect');
      })
    ),
  { functional: true, dispatch: false }
);

export const getClientPackagesOptionsEffect = createEffect(
  (actions$ = inject(Actions), packageConfiguratorService = inject(PackageConfiguratorService)): Observable<Action> =>
    actions$.pipe(
      ofType(getClientPackagesOptions),
      switchMap(() =>
        packageConfiguratorService.getPackages().pipe(
          map((packages: Package[]) => getClientPackagesOptionsSuccess(packages)),
          catchError(() => of(getClientPackagesOptionsFailure({ error: 'Failed to fetch packages' })))
        )
      )
    ),
  {
    functional: true,
    dispatch: true,
  }
);
